:host {
	display: block;
}

:host([fit-height]) {
	height: 100%;
}
